
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_global.mustache";
import "../settings/settings-list.mustache";
const TPL = handlebars_family.addTemplate("settings/page_settings",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcol class=\"pane-left settings-menu \"><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"headings.settings",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":153},"end":{"line":1,"column":183}}})) != null ? stack1 : "")
    + "</h1><div class=\"selectable\" style=\"margin-top:8px\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"settings/settings-list"),depth0,{"name":"settings/settings-list","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </div></flexcol><div class=\"pane-main\" style=\"border-left:var(--border);\" id=\"settings_content\"></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_global"),depth0,{"name":"layout/layout_global","hash":{"addButton":"inviteOnClickAction","pageKey":"mainMenu.settings","isPageSettings":true},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;